import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14, default as _styled15, default as _styled16, default as _styled17, default as _styled18, default as _styled19, default as _styled20, default as _styled21, default as _styled22, default as _styled23, default as _styled24, default as _styled25 } from "styled-components";
import type { Mode } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";
import { Headline } from "~/features/ui/headline";
import { Button } from "~/features/ui/button";
import { Slider } from "~/features/ui/slider";
import { Progress } from "~/features/ui/slider/progress";
import { Icon } from "~/features/ui/icon";
import { Media } from "~/features/ui/media";
import { Link } from "~/features/ui/link";
import { isLinkValid } from "~/features/ui/link/utils";
import { takeFirst } from "~/features/app/utils";
import { cleanStegaForTextTransform } from "~/features/sanity/stega";
import CaretLeft from "~/public/icons/caret-left.svg";
import CaretRight from "~/public/icons/caret-right.svg";
import { Section, CardProgressBar, SvgLogo, type PartnerGalleryLayoutProps } from "./shared";
import { usePartnerGallery } from "./use-partner-gallery";
export function PartnerGalleryDesktopView({
  anchor,
  items,
  mode,
  hasTopDivider,
  isHighlighted,
  sectionProps,
  showGalleryNavigation
}: PartnerGalleryLayoutProps) {
  const {
    activeIndex,
    sliderRef,
    sliderIndex,
    lastSlideIndex,
    cardContentRef,
    mediaContainerRef,
    changeSlide,
    handleAutoAdvance,
    handleSliderMounted,
    handleSliderMove,
    handleSliderResized
  } = usePartnerGallery(items.length);
  const activeItem = items[activeIndex];
  const activeLogo = activeItem?.logo;
  const activeLink = takeFirst(activeItem?.link);
  return <_StyledSection {...sectionProps} data-theme={mode as Mode} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css={[{
    "position": "relative",
    "display": "none",
    "@media (min-width: 1024px)": {
      "display": "block"
    }
  }, isHighlighted ? {
    "backgroundColor": "var(--white-static)",
    "color": "var(--black-static)"
  } : {
    "backgroundColor": "var(--bg-secondary)",
    "color": "var(--text-primary)"
  }]}>
      <_StyledWrap>
        <_StyledDiv $_css2={[{
        "padding": "var(--spacing-xl)"
      }, hasTopDivider && {
        "borderTopWidth": "1px",
        "borderColor": "var(--stroke-primary)"
      }]}>
          <_StyledDiv2 ref={mediaContainerRef} $_css3={[{
          "position": "relative",
          "height": "69rem",
          "overflow": "hidden",
          "borderRadius": "4px",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(69 69 69 / var(--tw-bg-opacity))"
        }]}>
            {items.map((item, idx) => {
            const media = item.media;
            return <_StyledDiv3 key={idx} data-media-idx={idx} style={{
              opacity: idx === activeIndex ? 1 : 0,
              transition: "opacity 1000ms cubic-bezier(0.4, 0, 0.2, 1)"
            }} $_css4={[{
              "position": "absolute",
              "inset": "0",
              "overflow": "hidden"
            }]}>
                  {media && <_StyledDiv4 data-zoom $_css5={[{
                "height": "100%",
                "width": "100%"
              }]}>
                      <Media {...media} imageProps={{
                  fit: "cover",
                  rounded: false,
                  loading: idx === 0 ? "eager" : "lazy"
                }} />
                    </_StyledDiv4>}
                </_StyledDiv3>;
          })}

            <_StyledDiv5 ref={cardContentRef} $_css6={[{
            "position": "relative",
            "zIndex": "10",
            "display": "flex",
            "height": "100%",
            "flexDirection": "column",
            "justifyContent": "space-between",
            "gap": "var(--spacing-xl)",
            "backgroundColor": "rgba(0, 7, 4, 0.2)",
            "padding": "var(--spacing-lg)",
            "--tw-text-opacity": "1",
            "color": "rgb(255 255 255 / var(--tw-text-opacity))",
            "--tw-backdrop-blur": "blur(16px)",
            "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)",
            "@media (min-width: 1024px)": {
              "width": "48rem"
            }
          }]}>
              <CardProgressBar key={`progress-${activeIndex}`} onComplete={handleAutoAdvance} />

              <div data-animate="logo">
                {activeLogo?.url && <_StyledSvgLogo src={activeLogo.url} alt={activeLogo.alt ?? ""} tone="light" />}
              </div>

              <_StyledDiv6 key={`content-${activeIndex}`} $_css7={[{
              "display": "flex",
              "flexDirection": "column",
              "alignItems": "flex-start",
              "gap": "var(--spacing-lg)"
            }]}>
                {activeItem?.title && <_StyledDiv7 data-animate="title" $_css8={[{
                "overflow": "hidden"
              }]}>
                    <_StyledHeadline type="h2" text={cleanStegaForTextTransform(activeItem.title)} />
                  </_StyledDiv7>}
                {activeItem?.description && <_StyledDiv8 data-animate="description">
                    {activeItem.description}
                  </_StyledDiv8>}
                {isLinkValid(activeLink) && <div data-animate="cta">
                    <Button as={Link} {...activeLink} variant="underline" />
                  </div>}
              </_StyledDiv6>
            </_StyledDiv5>

            {!showGalleryNavigation && <_StyledDiv9 $_css9={[{
            "position": "absolute",
            "bottom": "var(--spacing-sm)",
            "right": "var(--spacing-sm)",
            "zIndex": "10",
            "display": "flex",
            "overflow": "hidden",
            "borderRadius": "4px",
            "borderWidth": "1px",
            "borderColor": "var(--stroke-primary)"
          }]}>
                <_StyledButton type="button" aria-label="Previous slide" onClick={() => changeSlide(activeIndex > 0 ? activeIndex - 1 : items.length - 1)} $_css10={[{
              "display": "flex",
              "height": "3.2rem",
              "width": "3.2rem",
              "alignItems": "center",
              "justifyContent": "center",
              "backgroundColor": "rgba(0, 7, 4, 0.2)",
              "--tw-text-opacity": "1",
              "color": "rgb(255 255 255 / var(--tw-text-opacity))",
              "--tw-backdrop-blur": "blur(16px)",
              "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)"
            }]}>
                  <Icon icon={CaretLeft} size="16" aria-hidden />
                </_StyledButton>
                <_StyledButton2 type="button" aria-label="Next slide" onClick={() => changeSlide(activeIndex < items.length - 1 ? activeIndex + 1 : 0)} $_css11={[{
              "display": "flex",
              "height": "3.2rem",
              "width": "3.2rem",
              "alignItems": "center",
              "justifyContent": "center",
              "backgroundColor": "rgba(0, 7, 4, 0.2)",
              "--tw-text-opacity": "1",
              "color": "rgb(255 255 255 / var(--tw-text-opacity))",
              "--tw-backdrop-blur": "blur(16px)",
              "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)"
            }]}>
                  <Icon icon={CaretRight} size="16" aria-hidden />
                </_StyledButton2>
              </_StyledDiv9>}
          </_StyledDiv2>
        </_StyledDiv>

        {showGalleryNavigation && <>
            <_StyledDiv10 $_css12={[{
          "padding": "var(--spacing-xl)"
        }, hasTopDivider && {
          "borderTopWidth": "1px",
          "borderColor": "var(--stroke-primary)"
        }]}>
              <Slider ref={sliderRef} onMounted={handleSliderMounted} onMove={handleSliderMove} onResized={handleSliderResized} options={{
            perPage: 6,
            perMove: 1,
            gap: 16,
            breakpoints: {
              1024: {
                perPage: 3,
                gap: 12
              },
              640: {
                perPage: 2,
                gap: 8
              }
            }
          }}>
                {items.map((item, idx) => {
              const logo = item.logo;
              return <Slider.Slide key={idx} onClick={() => changeSlide(idx)}>
                      <_StyledDiv11 $_css13={[{
                  "display": "flex",
                  "height": "8rem",
                  "cursor": "pointer",
                  "alignItems": "center",
                  "justifyContent": "center",
                  "transitionProperty": "opacity",
                  "transitionDuration": "500ms"
                }, idx === activeIndex ? {
                  "opacity": "1"
                } : {
                  "opacity": "0.3"
                }]}>
                        {logo?.url && <_StyledSvgLogo2 src={logo.url} alt={logo.alt ?? ""} tone={isHighlighted || mode === "light" ? "dark" : "light"} position="left center" />}
                      </_StyledDiv11>
                    </Slider.Slide>;
            })}
              </Slider>
            </_StyledDiv10>

            {/* Controls */}
            <_StyledDiv12 $_css14={[{
          "display": "flex",
          "alignItems": "center",
          "gap": "var(--spacing-lg)",
          "paddingLeft": "var(--spacing-xl)",
          "paddingRight": "var(--spacing-xl)",
          "paddingBottom": "var(--spacing-xl)"
        }]}>
              {lastSlideIndex > 0 && <_StyledDiv13 $_css15={[{
            "flex": "1 1 0%"
          }]}>
                  <Progress activeSlideIndex={sliderIndex} totalSlides={lastSlideIndex + 1} />
                </_StyledDiv13>}
              <_StyledDiv14 $_css16={[{
            "display": "flex"
          }]}>
                <_StyledButton3 type="button" aria-label="Previous slide" onClick={() => sliderRef.current?.go("<")} disabled={sliderIndex === 0} $_css17={[{
              "display": "flex",
              "height": "3.2rem",
              "width": "3.2rem",
              "alignItems": "center",
              "justifyContent": "center",
              "borderRadius": "0",
              "borderBottomLeftRadius": "4px",
              "borderTopLeftRadius": "4px",
              "backgroundColor": "rgba(0, 7, 4, 0.2) !important",
              "color": "var(--text-primary)",
              "transitionProperty": "opacity"
            }]}>
                  <_StyledIcon icon={CaretLeft} size="16" aria-hidden $_css18={[sliderIndex === 0 && {
                "opacity": "0.3"
              }]} />
                </_StyledButton3>
                <_StyledButton4 type="button" aria-label="Next slide" onClick={() => sliderRef.current?.go(">")} disabled={sliderIndex >= lastSlideIndex} $_css19={[{
              "display": "flex",
              "height": "3.2rem",
              "width": "3.2rem",
              "alignItems": "center",
              "justifyContent": "center",
              "borderRadius": "0",
              "borderBottomRightRadius": "4px",
              "borderTopRightRadius": "4px",
              "backgroundColor": "rgba(0, 7, 4, 0.2) !important",
              "color": "var(--text-primary)",
              "transitionProperty": "opacity"
            }]}>
                  <_StyledIcon2 icon={CaretRight} size="16" aria-hidden $_css20={[sliderIndex >= lastSlideIndex && {
                "opacity": "0.3"
              }]} />
                </_StyledButton4>
              </_StyledDiv14>
            </_StyledDiv12>
          </>}
      </_StyledWrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled(Section).withConfig({
  componentId: "sc-sf-4chnpl-0"
})`${p => p.$_css}`;
var _StyledWrap = _styled2(Wrap).withConfig({
  componentId: "sc-sf-4chnpl-1"
})({
  "borderWidth": "0px"
});
var _StyledDiv = _styled3("div").withConfig({
  componentId: "sc-sf-4chnpl-2"
})`${p => p.$_css2}`;
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-4chnpl-3"
})`${p => p.$_css3}`;
var _StyledDiv3 = _styled5("div").withConfig({
  componentId: "sc-sf-4chnpl-4"
})`${p => p.$_css4}`;
var _StyledDiv4 = _styled6("div").withConfig({
  componentId: "sc-sf-4chnpl-5"
})`${p => p.$_css5}`;
var _StyledDiv5 = _styled7("div").withConfig({
  componentId: "sc-sf-4chnpl-6"
})`${p => p.$_css6}`;
var _StyledSvgLogo = _styled8(SvgLogo).withConfig({
  componentId: "sc-sf-4chnpl-7"
})({
  "height": "4.8rem",
  "@media (min-width: 1024px)": {
    "height": "6.4rem"
  }
});
var _StyledDiv6 = _styled9("div").withConfig({
  componentId: "sc-sf-4chnpl-8"
})`${p => p.$_css7}`;
var _StyledDiv7 = _styled10("div").withConfig({
  componentId: "sc-sf-4chnpl-9"
})`${p => p.$_css8}`;
var _StyledHeadline = _styled11(Headline).withConfig({
  componentId: "sc-sf-4chnpl-10"
})({
  "fontSize": "2rem",
  "lineHeight": "1.3",
  "letterSpacing": "0.02rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "2.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.024rem",
    "fontWeight": "400"
  }
});
var _StyledDiv8 = _styled12("div").withConfig({
  componentId: "sc-sf-4chnpl-11"
})({
  "fontSize": "1.6rem",
  "lineHeight": "1.5",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.8rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.018rem",
    "fontWeight": "400"
  }
});
var _StyledDiv9 = _styled13("div").withConfig({
  componentId: "sc-sf-4chnpl-12"
})`${p => p.$_css9}`;
var _StyledButton = _styled14("button").withConfig({
  componentId: "sc-sf-4chnpl-13"
})`${p => p.$_css10}`;
var _StyledButton2 = _styled15("button").withConfig({
  componentId: "sc-sf-4chnpl-14"
})`${p => p.$_css11}`;
var _StyledDiv10 = _styled16("div").withConfig({
  componentId: "sc-sf-4chnpl-15"
})`${p => p.$_css12}`;
var _StyledDiv11 = _styled17("div").withConfig({
  componentId: "sc-sf-4chnpl-16"
})`${p => p.$_css13}`;
var _StyledSvgLogo2 = _styled18(SvgLogo).withConfig({
  componentId: "sc-sf-4chnpl-17"
})({
  "height": "2rem",
  "@media (min-width: 1024px)": {
    "height": "2.4rem"
  }
});
var _StyledDiv12 = _styled19("div").withConfig({
  componentId: "sc-sf-4chnpl-18"
})`${p => p.$_css14}`;
var _StyledDiv13 = _styled20("div").withConfig({
  componentId: "sc-sf-4chnpl-19"
})`${p => p.$_css15}`;
var _StyledDiv14 = _styled21("div").withConfig({
  componentId: "sc-sf-4chnpl-20"
})`${p => p.$_css16}`;
var _StyledButton3 = _styled22("button").withConfig({
  componentId: "sc-sf-4chnpl-21"
})`${p => p.$_css17}`;
var _StyledIcon = _styled23(Icon).withConfig({
  componentId: "sc-sf-4chnpl-22"
})`${p => p.$_css18}`;
var _StyledButton4 = _styled24("button").withConfig({
  componentId: "sc-sf-4chnpl-23"
})`${p => p.$_css19}`;
var _StyledIcon2 = /*#__PURE__*/_styled25(Icon).withConfig({
  displayName: "desktop___StyledIcon2",
  componentId: "sc-17c5srv-0"
})(["", ""], p => p.$_css20);